import 'design-system/dist/fonts.scss';

import './index.scss';

import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { BraxLoading } from 'design-system';

import config from './config';
import languages from './languages';
import loader from './utils/loader';
import marketing from './utils/marketing';
import payment from './utils/payment';
import { IntlProvider } from './utils/i18n';
import ErrorBoundary from './components/ErrorBoundary';
import App from './App';

if (config.production)
    loader.loadJS('https://d335luupugsy2.cloudfront.net/js/loader-scripts/c51c1da5-aefc-4411-bfbe-de4e4ea6408f-loader.js')

marketing.checkParameters();

TagManager.initialize({ gtmId: 'GTM-KKZ5SN2' });

payment.load().catch(() => {});

export const rootNode = document.getElementById('root')!;

ReactDOM.createRoot(rootNode).render(
    <StrictMode>
        <Suspense fallback={<BraxLoading />}>
            <ErrorBoundary>
                <BrowserRouter>
                    <IntlProvider languages={languages}>
                        { () => <App /> }
                    </IntlProvider>
                </BrowserRouter>
            </ErrorBoundary>
        </Suspense>
    </StrictMode>
);
